import React, { useState, useEffect } from 'react'
import './Header.scss'

import Logo from '../../../assets/Pictures/logo-v4.svg'

import HomeIcon from '../../../assets/Pictures/home.svg'
import HomeActiveIcon from '../../../assets/Pictures/home-active.svg'
import HomeIconWhite from '../../../assets/Pictures/home-white.svg'

import MenuMobileIcon from '../../../assets/Pictures/MenuMobile.svg'
import closeIcon from '../../../assets/Pictures/closeIcon.svg'

import { Link, useNavigate } from 'react-router-dom'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function Header({ page }) {
  const navigate = useNavigate()

  const trHandler = (e) => {
    if (e.target.value === 'EN') {
      navigate('/')
    } else if (e.target.value === 'AR') {
      navigate('/ar')
    } else if (e.target.value === 'TR') {
      navigate('/tr')
    }
  }

  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])

  const [menu, setMenu] = useState(false)

  const menuHandler = () => {
    setMenu(true)
  }
  const closeMenuHandler = () => {
    setMenu(false)
  }

  return (
    <>
      <div className="cover" style={menu ? { display: '' } : { display: 'none' }}>
      </div>
      <div className="menuSideAr" style={menu ? { display: '' } : { display: 'none' }}>
        <div className="closeMenu" onClick={closeMenuHandler}>
          <img src={closeIcon} alt="closeIcon" />
        </div>
        <div className="menuSide_logo">
          <img src={Logo} alt="Logo" />
        </div>
        <ul>
          <li>
            <Link to='/ar'><img src={HomeIconWhite} alt="HomeIcon" /></Link>
          </li>
          <li>
            <Link to='/ar/corperate'>المؤسسية</Link>
          </li>
          <li>
            <Link to='/ar/products'>منتجاتنا</Link>
          </li>
          <li>
            <Link to='/ar/e-catalog'>البريد التسويقي</Link>
          </li>
          <li>
            <Link to='/ar/contact'>اتصالات</Link>
          </li>
        </ul>
      </div>
      <header className='mainHeader' data-aos= 'fade-up'>
      <div className='headerAr'>
        <div className="container">
          <div className="row">
            <div className="menuMobile">
              <img src={MenuMobileIcon} alt="MenuMobileIcon" onClick={menuHandler} />
            </div>
            <div className="logo">
              <Link to='/ar'>
                <img src={Logo} alt="Logo" />
              </Link>
            </div>
            <div className="menu">
              <nav>
                <ul>
                  <li>
                    <Link to='/ar'><img src={page === 'home' ? HomeActiveIcon : HomeIcon} alt="" /></Link>
                  </li>
                  <li >
                    <Link to='/ar/corperate' style={page === 'corperate' ? { color: '#C71324' } : {}}>المؤسسية</Link>
                  </li>
                  <li>
                    <Link to='/ar/products' style={page === 'products' ? { color: '#C71324' } : {}}>منتجاتنا</Link>
                  </li>
                  <li>
                    <Link to='/ar/e-catalog' style={page === 'ecatalog' ? { color: '#C71324' } : {}}>البريد التسويقي</Link>
                  </li>
                  <li>
                    <Link to='/ar/contact' style={page === 'contact' ? { color: '#C71324' } : {}}>اتصالات</Link>
                  </li>
                </ul>
              </nav>
              <div className="language">
                <select name="" id="" onChange={e => trHandler(e)}>
                  <option value="AR">AR</option>
                  <option value="EN">EN</option>
                  <option value="TR">TR</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    </>
  )
}
